import { render, staticRenderFns } from "./NewSelection.vue?vue&type=template&id=64049791&scoped=true"
import script from "./NewSelection.vue?vue&type=script&lang=js"
export * from "./NewSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64049791",
  null
  
)

export default component.exports